/**
 * Shadow Design Tokens
 * Warm-gray tinted shadows per Bennie style guide
 */

export const shadows = {
  none: 'none',
  // Neutral shadow scale (warm gray, not pure black)
  xs: '0 1px 2px rgba(0, 0, 0, 0.04)',
  sm: '0 1px 3px rgba(0, 0, 0, 0.04), 0 2px 8px rgba(0, 0, 0, 0.06)',
  md: '0 2px 6px rgba(0, 0, 0, 0.05), 0 8px 24px rgba(0, 0, 0, 0.1)',
  lg: '0 4px 12px rgba(0, 0, 0, 0.08), 0 16px 48px rgba(0, 0, 0, 0.12)',
  xl: '0 8px 24px rgba(0, 0, 0, 0.1), 0 24px 64px rgba(0, 0, 0, 0.15)',

  // Semantic surface elevations (aliases)
  surface: {
    base: '0 1px 3px rgba(0, 0, 0, 0.04), 0 2px 8px rgba(0, 0, 0, 0.06)',
    hover: '0 2px 6px rgba(0, 0, 0, 0.05), 0 8px 24px rgba(0, 0, 0, 0.1)',
  },

  // Colored shadows for interactive elements
  primary: {
    default: '0 2px 8px rgba(0, 103, 184, 0.3)',
    hover: '0 6px 20px rgba(0, 103, 184, 0.4)',
  },
  success: {
    default: '0 2px 8px rgba(16, 124, 16, 0.15)',
    hover: '0 6px 20px rgba(16, 124, 16, 0.2)',
  },
  gold: {
    default: '0 2px 8px rgba(255, 198, 39, 0.3)',
    hover: '0 6px 20px rgba(255, 198, 39, 0.45)',
  },
  error: {
    default: '0 2px 8px rgba(209, 52, 56, 0.25)',
    hover: '0 6px 20px rgba(209, 52, 56, 0.35)',
  },
} as const;

/**
 * Dark Mode Shadow Tokens
 * Per style guide §5.1: shadows suppressed in dark mode —
 * surfaces distinguished by background color, not shadow.
 * md/lg/xl kept for modals and elevated surfaces.
 */
export const shadowsDark = {
  none: 'none',
  xs: 'none',
  sm: 'none',
  md: '0 2px 8px rgba(0, 0, 0, 0.3)',
  lg: '0 4px 16px rgba(0, 0, 0, 0.4)',
  xl: '0 8px 32px rgba(0, 0, 0, 0.5)',
  surface: {
    base: 'none',
    hover: '0 2px 8px rgba(0, 0, 0, 0.3)',
  },
  primary: {
    default: 'none',
    hover: '0 4px 16px rgba(51, 153, 255, 0.25)',
  },
  success: {
    default: 'none',
    hover: '0 4px 16px rgba(76, 175, 80, 0.2)',
  },
  gold: {
    default: 'none',
    hover: '0 4px 16px rgba(255, 198, 39, 0.35)',
  },
  error: {
    default: 'none',
    hover: '0 4px 16px rgba(239, 83, 80, 0.25)',
  },
} as const;

export type ShadowToken = typeof shadows;
